var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_gallery"}},[_c('v-carousel',{attrs:{"carousel_data":_vm.sliderItems,"slideWidth":540,"interval":3000000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }